// Filter enums and display labels for the billing dashboard. These mirror the
// values the payments_dashboard API accepts/returns — see
// docs/v2/private/rest/reports/payments_dashboard_doc.md.

// `credit` is omitted on purpose: it is the internal adjustment method, not
// something a clinic pays with, so it is not offered as a filter.
export const PAYMENT_METHODS = ['credit_card', 'ach', 'cash', 'check']

// `denied` is omitted on purpose: the API's base scope is Billing::Payment.valid
// (`where.not(status: :denied)`), so a denied filter could only ever return an
// empty table. It is a limbo status kept for history and never surfaced.
export const PAYMENT_STATUSES = [
  'pending',
  'capturing',
  'processed',
  'error',
  'chargeback',
  'refunded',
  'declined',
  'partially_refunded',
]

export const METHOD_LABELS = {
  credit_card: 'Credit card',
  ach: 'ACH',
  cash: 'Cash',
  check: 'Check',
}

export const PAYMENT_STATUS_LABELS = {
  pending: 'Pending',
  capturing: 'Capturing',
  processed: 'Processed',
  error: 'Error',
  chargeback: 'Chargeback',
  refunded: 'Refunded',
  declined: 'Declined',
  partially_refunded: 'Partially refunded',
}
